import React from "react";
//#region types
import { ReceiptVouchersProps } from "models/propTypes/receiptPropTypes";
//#endregion
//#region components
import { Vouchers } from "components/voucher";
import { useReceiptService } from "serviceHooks";
//#endregion

const ReceiptVouchers: React.FC<ReceiptVouchersProps> = (props) => {
  const receiptService = useReceiptService();
  return <Vouchers parentId={props.id} getVouchersHandler={receiptService.getTransactions} />;
};

export default ReceiptVouchers;
